import { SearchOutlined } from '@mui/icons-material'
import { IconButton, Input, Pagination, TextField } from '@mui/material'
import NotFoundMessage from 'components/NotFoundMessage'
import TableLoadingAnimation from 'components/TableLoadingAnimation'
import { cloneDeep } from 'lodash'
import moment from 'moment'
import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { toast } from 'react-toastify'
import { get } from 'services/api'
import { reportError } from 'utils/errorReporter'
import BlockedTable from './BlockedTable'

import styles from './styles'

const initialValues = {
  search: '',
  dateStart: '',
  dateEnd: '',
}

export default function Blocked() {
  const classes = styles()
  const token = useSelector((state) => state.auth.access_token)
  const [formState, setFormState] = useState(initialValues)
  const [page, setPage] = useState(1)
  const [pagesNumber, setPagesNumber] = useState(1)
  const [list, setList] = useState([])
  const [loading, setLoading] = useState(false)

  const handleChangeFormValue = (event) => {
    const key = event.target.id
    const newFormState = cloneDeep(formState)
    newFormState[key] = event.target.value
    setFormState(newFormState)
  }

  const loadData = async () => {
    const { search, dateStart, dateEnd } = formState
    setLoading(true)
    get({
      url: '/antifraude/list/blocked',
      token,
      params: {
        search: search !== '' ? search : null,
        date_start: dateStart ? moment(dateStart).format('YYYY-MM-DD') : null,
        date_end: dateEnd ? moment(dateEnd).format('YYYY-MM-DD') : null,
        page,
      },
    })
      .then((response) => {
        setList(response.data.items)
        setPagesNumber(response.data.pages)
      })
      .catch((e) => {
        reportError(e)
        toast.error(
          'Houve um erro ao obter a lista de candidatos bloqueados, por favor tente novamente atualizando a página.',
        )
        setList([])
      })
      .finally(() => {
        setLoading(false)
      })
  }

  const handleUpdateData = () => {
    loadData()
  }

  const handleEnter = (event) => {
    if (event.keyCode === 13) {
      event.preventDefault()
      loadData()
    }
    return false
  }

  const handlePageChange = (event, value) => {
    setPage(value)
  }

  useEffect(() => {
    loadData()
  }, [formState.dateEnd, formState.dateStart, page])

  return (
    <div className={classes.root}>
      <header className={classes.header}>
        <h2>Candidatos bloqueados</h2>
        <div className={classes.searchForm}>
          <div className={classes.leftWrapper}>
            <Input
              type="search"
              id="search"
              placeholder="Digite o CPF da pessoa"
              value={formState.search}
              onChange={handleChangeFormValue}
              onKeyUp={handleEnter}
              fullWidth
            />
            <IconButton onClick={loadData}>
              <SearchOutlined />
            </IconButton>
          </div>
          <div className={classes.rightWrapper}>
            <TextField
              variant="standard"
              id="dateStart"
              label="Data início:"
              type="date"
              defaultValue={formState.dateStart}
              InputLabelProps={{
                shrink: true,
              }}
              onChange={handleChangeFormValue}
            />
            <TextField
              variant="standard"
              label="Data fim:"
              id="dateEnd"
              type="date"
              defaultValue={formState.dateEnd}
              InputLabelProps={{
                shrink: true,
              }}
              inputProps={{
                min: formState.dateStart,
              }}
              onChange={handleChangeFormValue}
            />
          </div>
        </div>
      </header>
      <article className={classes.table}>
        {loading ? (
          <TableLoadingAnimation />
        ) : list.length > 0 ? (
          <BlockedTable tableData={list} handleUpdate={handleUpdateData} />
        ) : (
          <NotFoundMessage message="Não foi encontrado nenhum bloqueio pendente" />
        )}
      </article>
      <footer className={classes.pagination}>
        <Pagination
          count={pagesNumber}
          page={page}
          onChange={handlePageChange}
        />
      </footer>
    </div>
  )
}
